import {
  InspectorControlsAppearance,
  InspectorControlsGeneral,
  InspectorTabs,
} from '@components/inspector-tabs';
import Visibility from '@components/visibility';
import ClassDropdown, { getBlockClassNames } from '@components/class-dropdown';
import { DEFAULT_CSS_CLASS } from '@constants';
import {
  useBlockProps,
  useInnerBlocksProps,
  store as blockEditorStore,
  __experimentalBlockVariationPicker as BlockVariationPicker,
} from '@wordpress/block-editor';
import classnames from 'classnames';
import variations from './variations/index';
import { counterIcon } from './icons';
import Label from '@components/block-label';
import './editor.scss';

const {
  i18n: { __ },
  data: { useDispatch, useSelect },
  blocks: { createBlocksFromInnerBlocksTemplate },
} = wp;

const VariationPicker = ({ clientId, setAttributes }) => {
  const { replaceInnerBlocks } = useDispatch(blockEditorStore);
  // when skip, first variant will be set as a default
  const defaultVariation = variations[0];
  return (
    <BlockVariationPicker
      variations={variations}
      label={__('Counter', 'b3rg')}
      instructions={__('Choose a variation to start with.', 'b3rg')}
      icon={counterIcon}
      onSelect={(variation = defaultVariation) => {
        if (variation.attributes) {
          setAttributes(variation.attributes);
        }
        if (variation.innerBlocks) {
          replaceInnerBlocks(
            clientId,
            createBlocksFromInnerBlocksTemplate(variation.innerBlocks),
            true,
          );
        }
      }}
      allowSkip
    />
  );
};

const InspectorGeneral = ({ label, blockVisibility, setAttributes }) => (
  <InspectorControlsGeneral>
    <Label {...{ label, setAttributes }} />
    <Visibility {...{ blockVisibility, setAttributes }} />
  </InspectorControlsGeneral>
);

const InspectorAppearance = ({
  blockClassNames,
  setAttributes,
  defaultBlockCssClass,
}) => (
  <InspectorControlsAppearance>
    <ClassDropdown
      {...{
        blockClassNames,
        setAttributes,
        blockClassPrefix: defaultBlockCssClass,
      }}
    />
  </InspectorControlsAppearance>
);

const DisplayBlocks = (props) => {
  const { attributes, setAttributes } = props;
  const { blockVisibility, allowedBlocks, blockClassNames, label } = attributes;

  const defaultBlockCssClass = DEFAULT_CSS_CLASS.COUNTER;
  const defaultBlockDynamicCssClass = `${defaultBlockCssClass}`;
  const classNames = getBlockClassNames(blockClassNames);

  const blockProps = useBlockProps({
    className: classnames({
      [`${defaultBlockCssClass}`]: true,
      [`${defaultBlockDynamicCssClass}`]: defaultBlockDynamicCssClass,
      [`${classNames}`]: classNames,
      disable: !blockVisibility,
    }),
  });

  const innerBlocksProps = useInnerBlocksProps(blockProps, {
    allowedBlocks,
  });

  return (
    <>
      <InspectorTabs>
        <InspectorGeneral {...{ label, blockVisibility, setAttributes }} />
        <InspectorAppearance
          {...{ blockClassNames, setAttributes, defaultBlockCssClass }}
        />
      </InspectorTabs>
      <div {...innerBlocksProps} />
    </>
  );
};

const Edit = (props) => {
  const { clientId } = props;
  const hasInnerBlocks = useSelect(
    (select) => select(blockEditorStore).getBlocks(clientId).length > 0,
    [clientId],
  );
  const Component = hasInnerBlocks ? DisplayBlocks : VariationPicker;
  return <Component {...props} />;
};

export default Edit;
